import { render, staticRenderFns } from "./AnimatedScrollDown.vue?vue&type=template&id=1d61beee&scoped=true&"
import script from "./AnimatedScrollDown.vue?vue&type=script&lang=js&"
export * from "./AnimatedScrollDown.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedScrollDown.vue?vue&type=style&index=0&id=1d61beee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d61beee",
  null
  
)

export default component.exports